import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const typeStyles = {
  secondarySub: (theme) => ({
    color: theme.palette.text.secondary,
    fontSize: 12,
  }),

  display_large: () => ({ fontSize: 57 }),
  display_medium: () => ({ fontSize: 45 }),
  display_small: () => ({ fontSize: 36 }),

  headline_large: () => ({ fontSize: 32 }),
  headline_medium: () => ({ fontSize: 28 }),
  headline_small: () => ({ fontSize: 24 }),

  title_large: () => ({ fontSize: 22, fontWeight: 500 }),
  title_medium: () => ({ fontSize: 16 }),
  title_small: () => ({ fontSize: 14 }),

  label_large: () => ({ fontSize: 14 }),
  label_medium: (theme) => ({ color: alpha(theme.palette.text.primary, 0.6), fontSize: 12 }),
  label_small: () => ({ fontSize: 11 }),
  label_tiny: () => ({ fontSize: 10 }),

  body_large: () => ({ fontSize: 16 }),
  body_medium: () => ({ fontSize: 14 }),
  body_small: () => ({ fontSize: 12 }),
};

export const StyledText = styled(Typography, {
  shouldForwardProp: (prop) => !['type', 'bold', 'italic', 'center'].includes(prop),
})(({ theme, type, bold, italic, center }) => ({
  ...(typeStyles[type] ? typeStyles[type](theme) : {}),
  ...(bold && { fontWeight: 'bold', transition: 'font-size 0.15s' }),
  ...(italic && { fontStyle: 'italic' }),
  ...(center && { textAlign: 'center' }),
}));
